export default __webpack_public_path__ + "static/media/repairShop.404c0910.png";